export const actionTypes = {
  REQUEST_START: 'CONTACTS.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'CONTACTS.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'CONTACTS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.REQUEST_FAILURE',
  DELETE_REQUEST_START: 'CONTACTS.DELETE.REQUEST_START',
  DELETE_REQUEST_SUCCESS: 'CONTACTS.DELETE.REQUEST_SUCCESS',
  DELETE_REQUEST_FAILURE: 'CONTACTS.DELETE.REQUEST_FAILURE',
  SET_NEED_UPDATE: 'CONTACTS.NEED_UPDATE.SET',
  SET: 'CONTACTS.TAX_AUTHORITY.SET',
  DELETE: 'CONTACTS.TAX_AUTHORITY.DELETE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data, successors) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
    successors,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function setNeedUpdate() {
  return {
    type: actionTypes.SET_NEED_UPDATE,
  };
}

export function startDeleteRequest(data) {
  return {
    type: actionTypes.DELETE_REQUEST_START,
    payload: data,
  };
}

export function deleteRequestSuccess(data) {
  return {
    type: actionTypes.DELETE_REQUEST_SUCCESS,
    payload: data,
  };
}

export function deleteRequestFailure(error, data) {
  return {
    type: actionTypes.DELETE_REQUEST_FAILURE,
    payload: {
      ...data,
      error,
    },
  };
}

export function setTaxAuthority(data) {
  return {
    type: actionTypes.SET,
    payload: data,
  };
}

export function deleteTaxAuthority(taxCode) {
  return {
    type: actionTypes.DELETE,
    payload: taxCode,
  };
}
